import { Navigate, Outlet } from 'react-router-dom';
import secureLocalStorage  from  "react-secure-storage";

export default function Protected() {
  const authed = secureLocalStorage.getItem('token');
  if (!authed) {
    return <Navigate to="/login" />;
  }

  return <Outlet />;
}
